<template>
  <div v-if="sentImprovesPopup" class="custom-popup-overlay">
    <div class="custom-popup">
      <button class="close-button" @click="closeNotePopup">
        <span>×</span>
      </button>
      <div class="popup-content">
        <div class="check-icon-container">
          <div class="check-icon">
            <svg viewBox="0 0 24 24" width="100" height="100" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 12L9 17L20 6" stroke="#4DDBC2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
        <h5>ההצעות לשיפור נשלחו ליזמים:</h5>
        <div class="ent-list">
          <div class="ent" v-for="ent in imporvesEnts" :key="ent.id">
            <span>{{ ent.name }}</span>
          </div>
        </div>
        <button class="action-button" @click="closeNotePopup">
          חזרה לשיפור הצעות במכרז
        </button>
        <div class="additional-info">
          <div class="info-item">
            <span class="info-icon">↗</span>
            <p>לאחר השליחת ההערות לסעיפים שסימנתם תוכלו לראות את ההערות בתצוגת "הערות חדשות"</p>
          </div>
          <div class="info-item">
            <span class="info-icon">↗</span>
            <p>במידה ואתם עדיין לא מרוצים מההצעאות תוכלו להוסיף הערות חדשות ולשלוח את ההצעות לשיפור בשנית</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="clause-comparison" :style="entsWidthComputed">
    <nav class="type_ents">
      <ul class="types">
        <li v-for="type in contract.types" :key="type.id" :class="{selected: activeTypeId==type.id}" @click="activeTypeId=type.id">{{type.name}}</li>
      </ul>
      <div class="ents_container">
        <ul ref="ents" class="ents" @scroll="handleEntsScroll">
          <li v-for="ent in selectedEnts" :key="ent.id" :style="`--ent_width: var(--ent_width_${ent.id});`">
            {{ ent.name }}
            <div 
              class="resize-handle" 
              @mousedown="startResize($event, ent.id)"
            ></div>
          </li>
        </ul>
      </div>
    </nav>

    <div class="flex-table-container">
      <div ref="flexTable" class="flex-table" @scroll="handleTableScroll">
          <template v-for="(part, partIndex) in filteredParts" :key="'part-' + partIndex">
            <clause-part
            :part="part"
            :selected-ents="selectedEnts"
            :entsWidth="entsWidth"
            :mode="mode"
            @toggle-clause="toggleClauseContent"
            @handleTableScroll="handleTableScroll"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { resizeHandleMixin } from '@/mixins/resizeHandle';
import ClausePart from './ClausePart.vue';

export default {
  name: 'ClauseComparison',
  components: {
    ClausePart
  },
  mixins: [resizeHandleMixin],
  props: {
    selectedEnts: {
      type: Array,
      default: () => []
    },
    contract: {
      type: Object,
      default: () => {}
    },
    mode: {
      type: String,
      default: 'edit',
      validator: (value) => ['edit', 'watch'].includes(value)
    }
  },
  data() {
    return {
      activeTypeId: null,
      entsWidth: {},
      sentImprovesPopup: false
    }
  },
  computed: {
    filteredParts() {
      const parts = [];
      const type = this.contract.types.find(type => type.id === this.activeTypeId);
      
      const collectParts = (part) => {
        parts.push(part);
        if (part.parts && part.parts.length > 0) {
          part.parts.forEach(subPart => {
            collectParts(subPart);
          });
        }
      };
      
      if (type?.parts) {
        type.parts.forEach(part => {
          collectParts(part);
        });
      }
      
      return parts;
    },
    entsWidthComputed() {
      return this.selectedEnts.map(ent => `--ent_width_${ent.id}: ${this.entsWidth[ent.id]}px;`).join(';');
    },
    imporvesEnts() {
      const ents = this.contract.types.reduce((acc, type) => {
        if (type.parts) {
          type.parts.forEach(part => {
            if (part.clauses) {
              part.clauses.forEach(clause => {
                if (clause.notes?.length > 0) {
                  clause.notes.forEach(note => {
                    if (note.ents?.length > 0) {
                      note.ents.forEach(ent => {
                        if (!acc.some(existingEnt => existingEnt.id === ent.id)) {
                          acc.push(ent);
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        }
        return acc;
      }, []);
      
      return ents;
    }
  },
  methods: {
    handleTableScroll(element) {
      if (this.$refs.ents) {
        this.$refs.ents.scrollLeft = element.scrollLeft;
      }
    },
    closeNotePopup() {
      this.sentImprovesPopup = false;
    }
  },
  mounted() {
    this.activeTypeId = this.contract.types?.[0]?.id;
    this.entsWidth = this.selectedEnts.reduce((acc, ent) => {
      acc[ent.id] = 250;
      return acc;
    }, {});
  }
}
</script>

<style lang="scss" scoped>
.custom-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7) !important;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  direction: rtl;
}

.custom-popup {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  position: relative;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;

  .close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: #333;
    z-index: 2;
    
    &:hover {
      background-color: #f5f5f5;
    }
  }

  .popup-content {
    padding: 25px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .check-icon-container {
      margin-bottom: 15px;

      .check-icon {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        border: 2px solid #0A5687;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
        
        svg {
          width: 100px;
          height: 100px;
          
          path {
            stroke: #4DDBC2;
            stroke-width: 4;
          }
        }
      }
    }

    h5 {
      font-size: 18px;
      margin-bottom: 15px;
      font-weight: 600;
      color: #333;
    }

    .ent-list {
      display: flex;
      flex-direction: column;
      gap: 8px;
      width: 100%;
      margin-bottom: 25px;

      .ent {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px 15px;
        background-color: #f8f8f8;
        border-radius: 25px;
        font-weight: 500;
        position: relative;
        
        span {
          margin-left: 5px;
        }

        .plus-icon {
          width: 20px;
          height: 20px;
          background-color: #4DDBC2;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          margin-right: 8px;
          font-weight: bold;
        }
      }
    }

    .action-button {
      background-color: #4DDBC2;
      color: white;
      border: none;
      border-radius: 25px;
      padding: 12px 20px;
      font-size: 15px;
      font-weight: 500;
      cursor: pointer;
      margin-bottom: 20px;
      width: 100%;
      max-width: 350px;
      
      &:hover {
        background-color: darken(#4DDBC2, 5%);
      }
    }
  }
}

.additional-info {
  width: 100%;
  text-align: right;
}

.info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  
  .info-icon {
    margin-left: 8px;
    font-weight: bold;
    color: #0A5687;
    font-size: 14px;
  }
  
  p {
    margin: 0;
    font-size: 13px;
    color: #555;
    line-height: 1.4;
  }
}

.clause-comparison {
  --title_width: 380px;
  --ent_width: 250px;
  --ent_gap: var(--gap);
  --clause_width: calc(var(--ent_width) - var(--gap));
  display: flex;
  flex-direction: column;
  width: 100%;
  background: transparent !important;
  
  
  nav.type_ents { position: sticky; top: 25px; z-index: 9;
    ul.types { display: flex; gap: var(--gap_small); width: var(--title_width);
      li { cursor: pointer; flex: 1; text-align: center; background: #fff; border-top-left-radius: 24px; border-top-right-radius: 24px;
        & { padding-block: 15px; align-content: center; color: var(--dark_blue); font-weight: 700; font-size: var(--h3); }
        &.selected { background: var(--gray); color: var(--text_s);}
      }
    }
    .ents_container {  border-top-left-radius: 24px; background: var(--gray); flex: 1; overflow: hidden; padding-right: calc(var(--title_width) + var(--gap_xmid) + (var(--gap) / 2)); padding-left: var(--gap_xmid);
      ul.ents { 
        padding-block: 4px; 
        width: 100%; 
        overflow-x: auto; 
        display: flex; 
        user-select: none; /* Prevent text selection while dragging */
        cursor: grab;

        &::-webkit-scrollbar {
          display: none;
        }


        li {    position: relative;
          .resize-handle { cursor: col-resize; position: absolute; top: 0; bottom: 0; left: 0; display: block; width: 5px; height: 100%; 
            &::after { content: ''; width: 1px; background: #CCDAE2; height: 100%; margin: 0 auto;     display: block;}
            &:hover { background: var(--dark_blue); opacity: 0.3; 
              &::after { background: var(--dark_blue); opacity: 0.3; }
            }
          }
        }
        
        &:active {
          cursor: grabbing;
        }
        
        &::-webkit-scrollbar {
          height: 5px;
        } 
        li { font-weight: 600; padding-block: 10px; width: var(--ent_width); min-width: var(--ent_width); text-align: center; transition: width 0.3s ease;
          
          // .resize-handle {
          //   position: absolute;
          //   left: 0;
          //   top: 0;
          //   width: 4px;
          //   height: 100%;
          //   cursor: col-resize;
          //   background: transparent;
            
          //   &:hover {
          //     background: var(--dark_blue);
          //     opacity: 0.3;
          //   }
          // }
        }
        
        &:active {
          cursor: grabbing;
        }
      }
    }
  }
  
  .flex-table-container { padding: var(--gap_xmid); position: relative; background: #fff; }
  .flex-table { 
    display: block;
    width: 100%;
    // overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: thin;
    user-select: none; /* Prevent text selection while dragging */
    position: relative;
    
    cursor: grab;
    // .card_b { overflow: visible;}
    &:active {
      cursor: grabbing;
    }
    
    /* Disable grab cursor on flex-cell elements */
    .flex-cell, 
    .flex-cell * {
      cursor: default !important;
      user-select: text;
      
      &:active, 
      &:hover, 
      &:focus {
        cursor: default !important;
      }
    }
    
    /* Set pointer cursor for arrow-icon elements */
    .arrow-icon,
    .arrow-icon * {
      cursor: pointer !important;
      
      &:active, 
      &:hover, 
      &:focus {
        cursor: pointer !important;
      }
    }
    
    // &::-webkit-scrollbar {
    //   height: 10px;
    // }
    // &::-webkit-scrollbar-track {
    //   -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
    //   border-radius: 10px;
    // }
    // &::-webkit-scrollbar-thumb {
    //   border-radius: 10px;
    //   -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); 
    // }
  }
}
</style> 